import { VendorConfigMap } from '@steelbuy/vendor';
import { Dashboard } from '../app/components/dashboard/Dashboard';
import { DashboardListings } from '../app/components/dashboard-listings.tsx/DashboardListings';
import { ListingSearchResults } from '../app/components/listing-search-results/ListingSearchResults';
import { MyRFQsList } from '../app/components/my-rfqs/MyRFQsList';
import { MyRequestQuotesTable } from '../app/components/request-quotes/MyRequestQuotesTable';
import { SearchListings } from '../app/components/search-listings/SearchListings';

export const appVendorConfig: VendorConfigMap = {
    default: {
        components: { searchResults: ListingSearchResults, dashboard: Dashboard, myRfqs: MyRFQsList },
        features: {
            SELLER_SEARCH: true,
            SMART_MATCHING: true,
            DELIVERY_PROMISE: true,
            DYNAMIC_DELIVERY_PRICE: false,
            CLAIMS_POLICY: false,
            THICKNESS_TYPE: false,
            SHOW_SERVICE_FEE_NOTIFICATION: true,
            NON_PRIME_CATEGORIES: false,
            THIRD_PARTY_ADDRESSES: false,
        },
    },
    TNA: {
        components: {
            searchResults: SearchListings,
            dashboard: DashboardListings,
            myRfqs: MyRequestQuotesTable,
        },
        features: {
            SELLER_SEARCH: false,
            SMART_MATCHING: false,
            DELIVERY_PROMISE: false,
            DYNAMIC_DELIVERY_PRICE: true,
            CLAIMS_POLICY: true,
            THICKNESS_TYPE: true,
            SHOW_SERVICE_FEE_NOTIFICATION: false,
            NON_PRIME_CATEGORIES: true,
            THIRD_PARTY_ADDRESSES: true,
        },
    },
};
